import logo from "./logo.svg";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import Home from "./pages/Home";
import BookConsultant from "./pages/BookConsultant";
import AboutUs from "./components/Home/AboutUs/About";
import AboutPage from "./pages/AboutPage";
import OurTeam from "./pages/OurTeam";
import MemberDetails from "./pages/MemberDetails";

function App() {
  const routes = createBrowserRouter([
    {
      element: <MainLayout />,
      children: [
        { path: "/", element: <Home /> },
        { path: "bookConsultation", element: <BookConsultant /> },
        { path: "about", element: <AboutPage /> },
        { path: "ourTeam", element: <OurTeam /> },
        { path: "core1:id", element: <MemberDetails /> },
      ],
    },
  ]);

  return <RouterProvider router={routes} />;
}

export default App;
